
import { Component, Vue } from 'vue-property-decorator'
import OrderMallList from '@/views/industryMall/order/OrderMallList.vue'
import OrderReturnList from '@/views/industryMall/order/returnOrder/ReturnOrderList.vue'
import { getFinanceAuthority } from "@/api/iousServices";
import { Getter, Action } from "vuex-class";
@Component({
  name: 'OrderMall',
  components: { OrderMallList, OrderReturnList }
})
export default class OrderMall extends Vue {
  @Action setWhiteStrips!: (val: string) => void
  @Getter whiteStrips!: number
  @Getter companyId!: string
  $refs: {
    OrderMallList: OrderMallList
  }

  orderTypeText = '全部订单'

  orderId = ''

  showAction = false
  orderType = 1
  searchKey = ''

  actions = [
    {
      name: '全部订单',
      id:1
    },
    {
      name: '退货售后',
      id:2
    }
  ]

  fromPage = ''

  created() {
    this.orderTypeText = this.$route.query.orderName as string
    // 清除白条设置的本地缓存数据
    // window.localStorage.removeItem('FDWhite')
    this.fromPage = this.$route.query.from as string
    this.getAuthority()
  }
  activated() {
    this.orderId = this.$route.query.orderId as string
    this.fromPage = this.$route.query.from as string
    // // 添加缓存设置
    // this.orderTypeText = this.$route.query.orderName as string
    // 清除白条设置的本地缓存数据
    // window.localStorage.removeItem('FDWhite')
  }
  mounted() {
    this.$eventBus.$on('refreshStatus',(data) => {
      this.orderTypeText = data.status
      this.orderId = data.orderId
    })
  }

  onSearch(value: string) {
    // console.log('value',value)
    this.$refs.OrderMallList.onSearch(value)

  }

  /**
   * 切换订单类型
   */
  actionSelect(action) {
    console.log(action)
    this.orderTypeText = action.name
  }
  goShop() {
    if (this.fromPage === "authorizeConfirm" || this.$route.query.form === 'orderMall' || this.$route.query.form === 'detail') {
      this.$router.push('/shopMallOrder')
    } else {
      this.$router.back();
    }
  }
  getAuthority() {
    getFinanceAuthority({companyId: this.companyId}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        this.setWhiteStrips(data.whiteStrips)
      }
      console.log('getFinanceAuthority=',res);
    })
  }
}
